import { Component, effect, EventEmitter, HostBinding, Inject, OnInit, Output } from '@angular/core';
import { MatToolbar } from '@angular/material/toolbar';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { HeaderService } from './header-service/header.service';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import {
  currentLanguageSettingsKey,
  SettingsService,
} from '../services/indexed-db/object-stores/settings/settings.service';
import { LoginService } from '../login/login.service';
import { ENVIRONMENT } from '../../environments/environment.token';
import { EnvironmentInterface } from '../../environments/environment.interface';

@Component({
  selector: 'app-header-section',
  imports: [
    MatToolbar,
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    TranslatePipe,
    MatRadioButton,
    MatRadioGroup,
    FormsModule,
  ],
  templateUrl: './header-section.component.html',
  styleUrl: './header-section.component.scss',
})
export class HeaderSectionComponent implements OnInit {
  language = 'en';
  @Output() toggleSideNav = new EventEmitter<void>();
  userInitial = '?';

  // FR-03: Set CSS class on host element based on environment stage
  @HostBinding('class') get hostClass(): string {
    return 'stage-' + this.env.stage;
  }

  constructor(
    private router: Router,
    private translateService: TranslateService,
    public headerService: HeaderService,
    private settingsService: SettingsService,
    protected loginService: LoginService,
    @Inject(ENVIRONMENT) private env: EnvironmentInterface,
  ) {
    effect(() => {
      const isLoggedIn = this.loginService.isLoggedIn();
      if (isLoggedIn) {
        this.loginService.getUserInitial().then((initial) => {
          this.userInitial = initial;
        });
      } else {
        this.userInitial = '?';
      }
    });
  }

  ngOnInit(): void {
    this.headerService.updateHeader();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.headerService.updateHeader();
      });
    this.language = this.translateService.getCurrentLang();
    this.translateService.onLangChange.subscribe(
      (lang) => (this.language = lang.lang),
    );
  }

  updateLanguage() {
    this.translateService.use(this.language).subscribe(() => {
      this.headerService.updateHeader();
    });
    this.settingsService.replaceSetting({
      key: currentLanguageSettingsKey,
      value: this.language,
    });
  }
}
